import EngagementsBadges from "./engagements-badges"
import EngagementsEvents from "./engagements-events"
import EngagementsStatus from "./engagements-status"
import Tooltip from "../../../../tool-tip"
import { getStatusID } from "../../../../../utils"
import { STATUS_OPTIONS } from "../../../../../constants"
import { SubscriptionLog } from "../../../../../../types"

type Props = {
  info: SubscriptionLog
  onClick: (id: string) => void
}

const EngagementsCell = ({ info, onClick }: Props) => {
  const { email, source, id, first_name, last_name, loid } = info
  const status = getStatusID(info)
  const selectedStatusOption = STATUS_OPTIONS.find(so => so.id === status)

  const name =
    first_name || last_name ? `${first_name} ${last_name}` : "Unnamed"

  return (
    <td className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer" colSpan={2}>
      <div className="flex items-center">
        <div
          className="font-bold mr-2 hover:border-b border-neutral-500 leading-none"
          onClick={() => onClick(id)}
        >
          {name}
        </div>
        <Tooltip
          toolTipNode={<EngagementsStatus status={status} />}
          placement="top"
          text={selectedStatusOption?.tooltipText ?? ""}
        />
      </div>
      <div className="text-neutral-400 text-sm mt-2">{email}</div>
      <div className="flex items-center mt-2">
        <EngagementsBadges className="px-3" source={source} />
        <EngagementsEvents className="px-3" id={id} loid={loid} />
      </div>
    </td>
  )
}

export default EngagementsCell
